import { FC } from "react";
import { twMerge } from "tailwind-merge";
import type { CSSProperties } from "react";

export const parseEmbedPlayerMaxHeight = (
  heightQuery: string | string[] | undefined
): number | undefined => {
  const raw = Array.isArray(heightQuery) ? heightQuery[0] : heightQuery;
  if (!raw) return undefined;
  const value = Number(raw);
  return Number.isFinite(value) && value > 0 ? value : undefined;
};

export const getEmbedPlayerFrameStyle = (
  maxHeight?: number
): CSSProperties | undefined =>
  maxHeight ? { maxHeight: `${maxHeight}px` } : undefined;

export const EMBED_PLAYER_FRAME_CLASSNAME =
  "relative w-full aspect-video overflow-hidden bg-fds-always-black md:rounded-lg";

interface Props {
  maxHeight?: number;
}

const VideoEmbeddedSkeleton: FC<Props> = ({ maxHeight }) => {
  return (
    <div
      className={twMerge(EMBED_PLAYER_FRAME_CLASSNAME, "border-transparent")}
      style={getEmbedPlayerFrameStyle(maxHeight)}
    >
      <div className="absolute inset-0 bg-fds-primary animate-pulse" />
    </div>
  );
};

export default VideoEmbeddedSkeleton;
